import React, {createContext, useContext, ReactNode} from 'react'

type Value = object | undefined

const ValueContext = createContext<Value>({})

type ValueProviderProps = {
    value?: Value
    children: ReactNode
}

export const ValueProvider: React.FC<ValueProviderProps> = ({
    value, children
}: ValueProviderProps) => {
    return <ValueContext.Provider value={value}>
        {children}
    </ValueContext.Provider>
}

export const useValue = () => {
    return useContext(ValueContext)
}
